import { createFileRoute } from '@tanstack/react-router'
import { internAgreementSearchSchema } from '@/pages/agreements/model/internAgreementSearch'
import { InternAgreementsPage } from '@/pages/agreements/ui/InternAgreementsPage'

export const Route = createFileRoute('/my-agreements')({
  validateSearch: internAgreementSearchSchema,
  component: InternAgreementsPage,
})
